module.exports = __webpack_public_path__ + "img/revistas_np.06302aec.png";